import { Icon } from 'antd'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../providers/AuthProvider'
import styles from './index.module.less'

interface FooterProps {
	privacyPolicyLink: string
	versionNumber: string
	className?: string
}

const Footer: FC<FooterProps> = ({ privacyPolicyLink, versionNumber, className }) => {
	const { userHasPermission } = useAuth()
	const isMondagoAdmin = userHasPermission(['ServiceProvider.All.ReadWrite'])

	return (
		<div className={`${className || ''} ${styles.footer}`}>
			<ul className={styles.links}>
				{isMondagoAdmin && (
					<li>
						<Link to={'/admin'}>
							<Icon type='setting' /> Admin
						</Link>
					</li>
				)}
				<li>
					<Link to={'/terms'} target='_blank' rel='noopener noreferrer'>
						Terms and Conditions
					</Link>
				</li>
				<li>
					<a href={privacyPolicyLink} target='_blank' rel='noopener noreferrer'>
						Privacy Policy
					</a>
				</li>
			</ul>
			<p className={styles.version}>v{versionNumber}</p>
		</div>
	)
}

export default Footer
